import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import API from '../api/api';
import "./SchemeDetail.css"; // ✅ Add this

const SchemeDetail = () => {
  const { id } = useParams();
  const [scheme, setScheme] = useState(null);

  useEffect(() => {
    API.get(`/schemes/${id}`)
      .then(res => setScheme(res.data))
      .catch(console.error);
  }, [id]);

  if (!scheme) return <p className="loading">Loading...</p>;

  return (
    <div className="scheme-detail-container">
      <div className="scheme-detail-card shadow-lg">
        <h2 className="scheme-title text-center">{scheme.title}</h2>
        <div className="underline"></div>

        <p><strong>Category:</strong> {scheme.category}</p>
        <p><strong>State:</strong> {scheme.state}</p>
        <p className="description">{scheme.description}</p>

        {scheme.youtubeLink && (
          <div className="mt-4">
            <h5 className="section-title">Video Tutorial</h5>
            <div className="ratio ratio-16x9">
              <iframe 
                src={
                  scheme.youtubeLink.includes("youtube")
                    ? scheme.youtubeLink.replace("watch?v=", "embed/")
                    : scheme.youtubeLink
                }
                title="YouTube video"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        )}

        {scheme.applyLink && (
          <a className="btn apply-btn mt-4 w-100" href={scheme.applyLink} target="_blank" rel="noreferrer">
            Apply Now
          </a>
        )}

        <Link to="/schemes" className="btn back-btn mt-3 w-100">
          ← Back to Schemes
        </Link>
      </div>
    </div>
  );
};

export default SchemeDetail;
